import { Component, OnInit, Input } from '@angular/core';
import { Inject, ViewChild } from '@angular/core';
// import { HttpClient, HttpParams } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';

// Modelos
import { Estancia } from '../../../models/estancia';
import { ApiResult } from '../../../services/base.service';
import { Observable, } from 'rxjs';
import { map } from 'rxjs/operators';

// Servicios
import { EstanciasService } from '../../../services/estancias.service';
import { VisitasService } from '../../../services/visitas.service';

import { AgFileUploadComponent } from '../../ag-file-upload/ag-file-upload.component';
import { FileBrowserComponent } from '../../file-browser/file-browser.component';
import { AuthService } from '../../../services/auth.service';
import { TasacionArchivo} from '../../../models/TasacionArchivo';
import { TasacionesService } from '../../../services/tasaciones.service';
import { TasacionArchivoValues } from '../../../models/enums';

@Component({
  selector: 'app-check-fotos',
  templateUrl: './check-fotos.component.html',
  styleUrls: ['./check-fotos.component.scss']
})
export class CheckFotosComponent implements OnInit {

  public  estancias:                  Estancia[];
  public  ficherosVisitaEstanciaList: Observable<TasacionArchivo[]>[];

  @Input() idTasacion:  number;
  @Input() version:     number;
  tiposEstancias: Map<string, string>;

  constructor
  (
    private estanciasService:   EstanciasService,
    public _authService:        AuthService,
    public _TasacionesService:  TasacionesService,
    private visitaService:      VisitasService
  )
  {
    this.estancias = [];
    this.ficherosVisitaEstanciaList = [];
  }
xz


  ngOnInit() {
    console.log("Iniciando")
    this.loadData();

  }

  loadData(query: string = null) {
    console.log("Cargando datos...")
    this.getData();
  }

  getData()
  {
    console.log("Coger datos")
    this.estanciasService.getData
    (
      this.idTasacion,
      this.version,
      0,
      200,
      "IdEstancia",
      "asc",
      null,
      null
    ).subscribe( result =>
      {
        this.estancias = result.data;
        console.log("Estancias cargadas: "+this.estancias.length);
        console.log("Refrescando...");
        this.refreshAllEstancias();
      }, error => console.error(error)
    );
    this.estanciasService.getTipoEstancia().subscribe((res: Map<string, string>) => this.tiposEstancias = res);
  }

  onFileUploadedEstancia(event, idEstancia)
  {
    this.refreshAllEstancias();
  }

  FileDelete(TasacionArchivoID, idEstancia)
  {
    this._TasacionesService.removeArchivoTasacion(TasacionArchivoID).subscribe(data =>
    {
      this.refreshAllEstancias();
    });
  }

  refreshAllEstancias(){
    console.log("Refrescando estancias "+this.estancias.length)
    for (let estancia of this.estancias)
    {
      console.log("Detalles estancia...");
      console.log(estancia);
      console.log("id: "+estancia.idEstancia);
      console.log("Fin Detalles estancia...");
      this.refreshArchivosEstancia(estancia.idEstancia);
    }

  }

  refreshArchivosEstancia(idEstancia)
  {
    console.log("Refrescando imagenes de la estancia: "+idEstancia);
    if (this.idTasacion !== undefined)
    {
      const svcGeneric = this.visitaService.getFicherosVisita(this.idTasacion, this.version, idEstancia);
      this.ficherosVisitaEstanciaList[idEstancia] = svcGeneric.pipe(map((d) => {return d.filter( d2 => d2.tipoArchivo === TasacionArchivoValues.Fotos);}));

    }
    else
    {
      console.log('no refesh');
    }
  }

  showError()
  {
    console.log("estancias cargadas-> ");
    console.log(this.estancias);
  }
}
